import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CalendarCustomer } from 'app/core/store/calendar/common/calendar.interface';

@Component({
  selector: 'app-calendar-legend-customer',
  templateUrl: './calendar-legend-customer.component.html',
  styleUrls: ['./calendar-legend-customer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // don't always check for changes, only when input changed (but there's no input here)
})
export class CalendarLegendCustomerComponent {
  @Input() customer: CalendarCustomer;
}
